var cov_1r31ssl6ng = function () {
  var path = "/Users/spana/SHEIN/shineout/src/DatePicker/index.ts",
      hash = "65e93856f904b9f65a211969f85ae618bb9ab4b7",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/DatePicker/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 21
        },
        end: {
          line: 10,
          column: 105
        }
      },
      "1": {
        start: {
          line: 10,
          column: 35
        },
        end: {
          line: 10,
          column: 105
        }
      },
      "2": {
        start: {
          line: 12,
          column: 24
        },
        end: {
          line: 17,
          column: 12
        }
      },
      "3": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 45
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 21
          },
          end: {
            line: 10,
            column: 22
          }
        },
        loc: {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 10,
            column: 105
          }
        },
        line: 10
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 59
          },
          end: {
            line: 10,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 10,
            column: 71
          },
          end: {
            line: 10,
            column: 74
          }
        }, {
          start: {
            line: 10,
            column: 77
          },
          end: {
            line: 10,
            column: 80
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 10,
            column: 84
          },
          end: {
            line: 10,
            column: 102
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 10,
            column: 84
          },
          end: {
            line: 10,
            column: 92
          }
        }, {
          start: {
            line: 10,
            column: 96
          },
          end: {
            line: 10,
            column: 102
          }
        }],
        line: 10
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import inputBorder from '../hoc/inputBorder';
import inputable from '../Form/inputable';
import { compose } from '../utils/func';
import { datepickerClass } from './styles';
import Container from './Container';
import value from './value';
import absolute from '../Table/context';
cov_1r31ssl6ng.s[0]++;

var getClassName = function getClassName(opt) {
  cov_1r31ssl6ng.f[0]++;
  cov_1r31ssl6ng.s[1]++;
  return datepickerClass('_', "".concat(opt.range ? (cov_1r31ssl6ng.b[0][0]++, 'r') : (cov_1r31ssl6ng.b[0][1]++, 'c'), "-").concat((cov_1r31ssl6ng.b[1][0]++, opt.type) || (cov_1r31ssl6ng.b[1][1]++, 'date')));
};

var Datepicker = (cov_1r31ssl6ng.s[2]++, compose(inputable, inputBorder({
  className: getClassName,
  innerWidth: true
}), value, absolute)(Container));
cov_1r31ssl6ng.s[3]++;
Datepicker.displayName = 'ShineoutDatepicker';
export default Datepicker;